import { render, staticRenderFns } from "./NumberInputLabel.vue?vue&type=template&id=7723c4d8&"
import script from "./NumberInputLabel.vue?vue&type=script&lang=js&"
export * from "./NumberInputLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports